import axios from "axios";
import { axiosPublic } from "./axiosPublic";

const axiosApiInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

var userToken = JSON.parse(localStorage.getItem("userData") || "{}");

async function checkUpdateToken() {
  return new Promise((resolve, reject) => {
    userToken = JSON.parse(localStorage.getItem("userData") || "{}");
    resolve(true);
  });
}

axiosApiInstance.interceptors.request.use(
  async (config) => {
    await checkUpdateToken();
    config.headers = {
      Authorization: `Bearer ${userToken?.token}`,
      Accept: "application/json",
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

axiosApiInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      await refreshAccessToken();
      const newToken = JSON.parse(localStorage.getItem("userData") || "{}");
      userToken = newToken;
      axiosApiInstance.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${newToken?.token}`;
      originalRequest.headers.Authorization = `Bearer ${newToken?.token}`;
      return axiosApiInstance(originalRequest);
    }
    return Promise.reject(error);
  }
);

const refreshAccessToken = async () => {
  return new Promise(async (resolve, reject) => {
    const refreshToken = JSON.parse(localStorage.getItem("userData") || "{}");
    if (refreshToken.refresh_token !== undefined) {
      await axiosPublic
        .post("refresh-token", { refresh_token: refreshToken.refresh_token })
        .then(
          (response) => {
            localStorage.setItem("userData", JSON.stringify(response.data));
            resolve(response.data.token);
          },
          (error) => {
            reject(error.message);
          }
        );
    } else {
      localStorage.removeItem("userData");
      localStorage.removeItem("userDetails");
    }
  });
};

export default axiosApiInstance;
